import React, { useState } from 'react';

const CHIPP_BASE = 'https://eager-nodding-balloon-a9bw.on.chipp.ai';

export const StudyPage = ({ onLogoClick }) => {
  const [loaded, setLoaded] = useState(false);

  const params = new URLSearchParams(window.location.search);
  const variant = params.get('v');
  const token = params.get('r');
  const hasValidLink = Boolean(token);

  const iframeUrl = `${CHIPP_BASE}?v=${encodeURIComponent(variant || '')}&r=${encodeURIComponent(token || '')}`;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden', backgroundColor: '#FAF8F6' }}>
      <style>{`
        @media (max-width: 600px) {
          .study-header { padding: 0 16px !important; }
          .study-consent { padding: 8px 16px !important; gap: 12px !important; }
          .study-pill { font-size: 11px !important; }
        }
      `}</style>

      {/* Minimal header */}
      <header className="study-header" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 32px',
        height: '56px',
        backgroundColor: '#ffffff',
        borderBottom: '1px solid #E8E8E8',
        flexShrink: 0
      }}>
        <button
          onClick={onLogoClick}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <img
            src="/real-patients-logo.png"
            alt="Real Patients"
            style={{ height: '36px', display: 'block' }}
          />
        </button>
      </header>

      {/* Consent strip */}
      <div className="study-consent" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '20px',
        padding: '10px 32px',
        backgroundColor: '#FAF8F6',
        borderBottom: '1px solid #E8E8E8',
        flexShrink: 0
      }}>
        {['De-identified', 'Voluntary · stop anytime', '~20 min'].map(label => (
          <span key={label} className="study-pill" style={{
            fontSize: '12px',
            color: '#666666',
            display: 'flex',
            alignItems: 'center',
            gap: '5px'
          }}>
            <span style={{ color: '#B5C9A8', fontSize: '10px' }}>✓</span>
            {label}
          </span>
        ))}
      </div>

      {/* Iframe or invitation gate */}
      <div style={{ flex: 1, position: 'relative', overflow: 'hidden' }}>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>

        {!hasValidLink ? (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            padding: '40px 24px',
            textAlign: 'center',
            backgroundColor: '#FAF8F6'
          }}>
            <p style={{
              fontFamily: '"Source Serif Pro", Georgia, serif',
              fontSize: 'clamp(20px, 3vw, 26px)',
              color: '#272726',
              margin: '0 0 12px',
              maxWidth: '480px'
            }}>
              This page is only accessible via an email invitation.
            </p>
            <p style={{ fontSize: '15px', color: '#666666', margin: 0, maxWidth: '400px', lineHeight: 1.6 }}>
              If you received an email from Real Patients, please use the link in that email to access your conversation.
            </p>
          </div>
        ) : (
          <>
            {!loaded && (
              <div style={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#FAF8F6',
                gap: '12px'
              }}>
                <div style={{
                  width: '32px',
                  height: '32px',
                  border: '3px solid #E8E8E8',
                  borderTopColor: '#7FAFB2',
                  borderRadius: '50%',
                  animation: 'spin 0.8s linear infinite'
                }} />
                <p style={{ fontSize: '14px', color: '#888888', margin: 0 }}>
                  Loading your conversation...
                </p>
              </div>
            )}
            <iframe
              src={iframeUrl}
              onLoad={() => setLoaded(true)}
              title="Real Patients Research Conversation"
              allow="microphone"
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                display: 'block',
                opacity: loaded ? 1 : 0,
                transition: 'opacity 0.3s ease'
              }}
            />
          </>
        )}
      </div>
    </div>
  );
};
